function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}

class SectionId {
  static #separator = "__";

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section id (e.g. 'template--22224696705326')
  static parseId(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[0];
  }

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section name (e.g. 'main')
  static parseSectionName(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[1];
  }

  // for a section id (e.g. 'template--22224696705326') and a section name (e.g. 'recommended-products'), return a qualified section id (e.g. 'template--22224696705326__recommended-products')
  static getIdForSection(sectionId, sectionName) {
    return `${sectionId}${SectionId.#separator}${sectionName}`;
  }
}

class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(
    oldNode,
    newContent,
    preProcessCallbacks = [],
    postProcessCallbacks = [],
  ) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement("div");
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll("[id], [form]").forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form &&
        element.setAttribute(
          "form",
          `${element.form.getAttribute("id")}-${uniqueKey}`,
        );
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = "none";

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll("script").forEach((oldScriptTag) => {
      const newScriptTag = document.createElement("script");
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open"),
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open"),
    );
  });

  if (summary.closest("header-drawer, menu-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

var closeButton = document.querySelector(".product-media-modal__toggle");
if (closeButton) {
  closeButton.addEventListener("click", function () {
    var images = document.querySelector(".product-media-modal__content");
    var homePlate = document.querySelector(".product-media-modal__dialog");
    homePlate.appendChild(images);
    var navWrapper = document.querySelector(".navigation-wrapper");
    navWrapper.remove();
  });
}

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true,
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{ "event": "command", "func": "pauseVideo" }',
      "*",
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    // this.input = this.querySelector("input");
    // this.changeEvent = new Event("change", { bubbles: true });
    // this.input.addEventListener("change", this.onInputChange.bind(this));
    // this.querySelectorAll("button").forEach((button) =>
    //   button.addEventListener("click", this.onButtonClick.bind(this)),
    // );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    requestAnimationFrame(() => {
      console.log(this);
      this.input = this.querySelector("input");
      console.log(this.input);
      this.changeEvent = new Event("change", { bubbles: true });
      this.input.addEventListener("change", this.onInputChange.bind(this));
      this.querySelectorAll("button").forEach((button) =>
        button.addEventListener("click", this.onButtonClick.bind(this)),
      );
      this.validateQtyRules();
      this.quantityUpdateUnsubscriber = subscribe(
        PUB_SUB_EVENTS.quantityUpdate,
        this.validateQtyRules.bind(this),
      );
    });
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === "plus") {
      if (
        parseInt(this.input.dataset.min) > parseInt(this.input.step) &&
        this.input.value == 0
      ) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);

    if (
      this.input.dataset.min === previousValue &&
      event.target.name === "minus"
    ) {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.querySelector(".quantity__button[name='minus']")) {
      if (this.input.min) {
        const buttonMinus = this.querySelector(
          ".quantity__button[name='minus']",
        );
        buttonMinus.classList.toggle(
          "disabled",
          parseInt(value) <= parseInt(this.input.min),
        );
      }
    }
    if (this.querySelector(".quantity__button[name='plus']")) {
      if (this.input.max) {
        const max = parseInt(this.input.max);
        const buttonPlus = this.querySelector(".quantity__button[name='plus']");
        buttonPlus.classList.toggle("disabled", value >= max);
      }
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options,
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid,
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this),
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    setTimeout(() => {
      this.mainDetailsToggle = this.querySelector("details");
      console.log(this.mainDetailsToggle);

      this.addEventListener("keyup", this.onKeyUp.bind(this));
      this.addEventListener("focusout", this.onFocusOut.bind(this));
      this.bindEvents();
    }, 0);
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this)),
    );
    this.querySelectorAll(
      "button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)",
    ).forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this)),
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary"),
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const liElement = detailsElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      let focusable = detailsElement.querySelector("button");
      if (focusable == null) {
        focusable = detailsElement;
      }
      trapFocus(summaryElement.nextElementSibling, focusable);
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus,
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`,
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        liElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus,
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`,
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    elementToFocus?.setAttribute("aria-expanded", false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary"),
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector(".section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom",
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`,
    );
    this.header.classList.add("menu-open");

    if (this.mainDetailsToggle.classList.contains("mobile_menu_drawer")) {
      this.setUtltilityLinksHeight();
    }

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    window.addEventListener("resize", this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
    window.removeEventListener("resize", this.onResize);
  }

  setUtltilityLinksHeight() {
    let utilityLinks = this.querySelector(".menu-drawer__utility-links");
    let utilityLinksHeight = utilityLinks.offsetHeight;
    document.documentElement.style.setProperty(
      "--utlity-links-height",
      `${utilityLinksHeight}px`,
    );
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`,
      );
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`,
    );
  };
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false),
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      // this.addEventListener('pointerup', (event) => {
      //   console.log('test');
      //   if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      // });

      this.addEventListener("click", (event) => {
        if (event.target.nodeName === "IMG") {
          event.target.classList.toggle("zoom");
          // if (event.target.classList.contains('zoom')) {
          //   event.target.style.zoom = '107%';
          // } else {
          //   event.target.style.zoom = 'unset';
          // }
        }
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    this.dataset.section = this.closest(".shopify-section").id.replace(
      "shopify-section-",
      "",
    );
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class BulkModal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      if (this.innerHTML.trim() === "") {
        const productUrl = this.dataset.url.split("?")[0];
        fetch(`${productUrl}?section_id=bulk-quick-order-list`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html",
            );
            const sourceQty = html.querySelector(
              ".quick-order-list-container",
            ).parentNode;
            this.innerHTML = sourceQty.innerHTML;
          })
          .catch((e) => {
            console.error(e);
          });
      }
    };

    new IntersectionObserver(handleIntersection.bind(this)).observe(
      document.querySelector(
        `#QuickBulk-${this.dataset.productId}-${this.dataset.sectionId}`,
      ),
    );
  }
}

customElements.define("bulk-modal", BulkModal);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;

    //console.log(this, poster);
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    //console.log('loadContent', this);
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(
          true,
        ),
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe"),
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");    
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.sliderDotButtons = this.querySelectorAll("[data-slider-dot]");
    this.sliderList = this.querySelector(".collection-subcollections--list");

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));

    if (this.sliderDotButtons) {
      this.sliderDotButtons.forEach((dot) => {
        dot.addEventListener(
          "click",
          this.sliderDotButtonClickHandle.bind(this),
        );
      });
    }
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0,
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.round(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset,
    );

    this.totalPages = Math.max(1, this.sliderItemsToShow.length - this.slidesPerPage + 1);
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;
      
    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    let thisPageDot = this.querySelector(
      `[data-slider-dot][data-index='${this.currentPage - 1}'`,
    );
    if (thisPageDot != null) {
      this.sliderDotButtons.forEach((dot) => dot.classList.remove("active"));
      thisPageDot.classList.add("active");
    }

    if(this.totalPages > 1)
    {
      this.sliderList.classList.remove('centre_cards');
    }
    else
    {
      this.sliderList.classList.add('centre_cards');
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        }),
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1],
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }
    

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  sliderDotButtonClickHandle(e) {
    e.preventDefault();
    let button = e.target.closest("button");
    if (button.classList.contains("active")) return;

    let index = parseInt(button.dataset.index);
    let step = index - (this.currentPage - 1);
    this.slideScrollPosition =
      this.slider.scrollLeft + step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }  
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector(".announcement-bar-slider");
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link"),
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this)),
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)",
      );
      this.reducedMotion.addEventListener("change", () => {
        if (this.slider.getAttribute("data-autoplay") === "true")
          this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          "click",
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true },
        );
      });
    }

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    if (this.querySelector(".slideshow__autoplay")) {
      this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
      this.sliderAutoplayButton.addEventListener(
        "click",
        this.autoPlayToggle.bind(this),
      );
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active",
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true,
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed,
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow,
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow,
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = "next") {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === "next" ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = "announcement-bar-slider--fade-in";
    const animationClassOut = "announcement-bar-slider--fade-out";

    const direction = button === "next" ? "next" : "previous";

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();

    this.productData = null;
    try {
      this.productData = JSON.parse(
        this.querySelector("[data-product-json]").innerText,
      );
    } catch {
      this.productData = null;
    }
  }

  connectedCallback() {
    this.addEventListener("change", (event) => {
      const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);

      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues,
        },
      });
    });
  }

  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;

    if (tagName === "SELECT" && target.selectedOptions.length) {
      Array.from(target.options)
        .find((option) => option.getAttribute("selected"))
        .removeAttribute("selected");
      target.selectedOptions[0].setAttribute("selected", "selected");

      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target
        .closest(".product-form__input")
        .querySelector("[data-selected-value] > .swatch");
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty(
          "--swatch--background",
          swatchValue,
        );
        selectedDropdownSwatchValue.classList.remove("swatch--unavailable");
      } else {
        selectedDropdownSwatchValue.style.setProperty(
          "--swatch--background",
          "unset",
        );
        selectedDropdownSwatchValue.classList.add("swatch--unavailable");
      }

      selectedDropdownSwatchValue.style.setProperty(
        "--swatch-focal-point",
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || "unset",
      );
    } else if (tagName === "INPUT" && target.type === "radio") {
      const selectedSwatchValue = target
        .closest(`.product-form__input`)
        .querySelector("[data-selected-value]");
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === "SELECT" ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {
    return Array.from(
      this.querySelectorAll("select option[selected], fieldset input:checked"),
    ).map(({ dataset }) => dataset.optionValueId);
  }

  get selectedOptionNames() {
    return Array.from(
      this.querySelectorAll("select option[selected], fieldset input:checked"),
    ).map((input) => input.value);
  }

  getOptionNamesByVariantIds(variantIds) {
    if (this.productData == null) return [];

    let variants = this.productData.variants.filter((variant) =>
      variantIds.includes(variant.id),
    );
    return variants.map((variant) => variant.options);
  }

  selectedOptionsDynamically(optionArray) {
    let changedInputs = [];

    optionArray.forEach((optionValue, index) => {
      let optionContainer = this.querySelector(`[data-position='${index}']`);
      let allInputs = optionContainer.querySelectorAll("input, option");
      allInputs.forEach((input) => {
        if (input.tagName == "OPTION") {
          input.removeAttribute("selected");
          input.selected = false;
        } else {
          input.removeAttribute("checked");
          input.checked = false;
        }
      });

      let inputToSelect = optionContainer.querySelector(
        `[value='${optionValue}']`,
      );
      if (inputToSelect.tagName == "OPTION") {
        inputToSelect.selected = true;
      } else {
        inputToSelect.checked = true;
      }
    });

    let firstChangedInput = this.querySelectorAll("input, option")[0];
    if (firstChangedInput.tagName == "OPTION") {
      let select = firstChangedInput.closest("select");
      select.dispatchEvent(new Event("change", { bubbles: true }));
    } else {
      firstChangedInput.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }
}

customElements.define("variant-selects", VariantSelects);

class ProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }

  connectedCallback() {
    this.loadingElement = this.querySelector("[data-klevu-loading]");
    this.klevuLimit = parseInt(this.dataset.klevuLimit || 0);

    if (this.klevuLimit > 0) {
      this.showLoading();
    }

    this.initializeRecommendations(this.dataset.productId);

    document.addEventListener("klevu:loaded", (event) => {
      if (event.detail?.count > 0) {
        this.hideLoading();
      } else {
        this.showLoadingError();
      }
    });
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        // this.loadRecommendations(productId); -- commented out as it reset the results when scrolling down, removing the Klevu results
      },
      { rootMargin: "0px 0px 400px 0px" },
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    fetch(
      `${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`,
    )
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector("product-recommendations");

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        // if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
        //   this.remove();
        // }

        if (html.querySelector(".grid__item")) {
          this.classList.add("product-recommendations--loaded");
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
  showLoading() {
    this.loadingElement?.classList.remove("hidden");
  }
  hideLoading() {
    this.loadingElement?.classList.add("hidden");
  }
  showLoadingError() {
    if (this.loadingElement) {
      const message = this.loadingElement.querySelector("p");
      if (message) {
        message.textContent = "No recommendations to show, refresh the page and try again.";
      }
    }
  }
}
customElements.define("product-recommendations", ProductRecommendations);

class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector(".icon");
  }

  connectedCallback() {
    document.addEventListener(
      "storefront:signincompleted",
      this.handleStorefrontSignInCompleted.bind(this),
    );
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define("account-icon", AccountIcon);

class BulkAdd extends HTMLElement {
  constructor() {
    super();
    this.queue = [];
    this.requestStarted = false;
    this.ids = [];
  }

  startQueue(id, quantity) {
    this.queue.push({ id, quantity });
    const interval = setInterval(() => {
      if (this.queue.length > 0) {
        if (!this.requestStarted) {
          this.sendRequest(this.queue);
        }
      } else {
        clearInterval(interval);
      }
    }, 250);
  }

  sendRequest(queue) {
    this.requestStarted = true;
    const items = {};
    queue.forEach((queueItem) => {
      items[parseInt(queueItem.id)] = queueItem.quantity;
    });
    this.queue = this.queue.filter(
      (queueElement) => !queue.includes(queueElement),
    );
    const quickBulkElement =
      this.closest("quick-order-list") || this.closest("quick-add-bulk");
    quickBulkElement.updateMultipleQty(items);
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute("value");
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;

    if (inputValue < event.target.dataset.min) {
      this.setValidity(
        event,
        index,
        window.quickOrderListStrings.min_error.replace(
          "[min]",
          event.target.dataset.min,
        ),
      );
    } else if (inputValue > parseInt(event.target.max)) {
      this.setValidity(
        event,
        index,
        window.quickOrderListStrings.max_error.replace(
          "[max]",
          event.target.max,
        ),
      );
    } else if (inputValue % parseInt(event.target.step) != 0) {
      this.setValidity(
        event,
        index,
        window.quickOrderListStrings.step_error.replace(
          "[step]",
          event.target.step,
        ),
      );
    } else {
      event.target.setCustomValidity("");
      event.target.reportValidity();
      this.startQueue(index, inputValue);
    }
  }

  getSectionsUrl() {
    if (window.pageNumber) {
      return `${window.location.pathname}?page=${window.pageNumber}`;
    } else {
      return `${window.location.pathname}`;
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }
}

if (!customElements.get("bulk-add")) {
  customElements.define("bulk-add", BulkAdd);
}

class ProductCard extends HTMLElement {
  constructor() {
    super();

    this.originalProductId = this.dataset.originalProductId;
    this.originalProductVariantId = this.dataset.originalProductVariantId;
    this.addToCartText = this.dataset.addToCartText;
    this.orderSampleText = this.dataset.orderSampleText;
    this.soldOutText = this.dataset.soldOutText;
    this.collectionPage = this.dataset.page;
    this.productDataCache = {};
  }

  connectedCallback() {
    this.link = this.querySelector("a")?.href || null;
    this.carousel = this.querySelector("product-card-carousel");
    this.swatches = this.querySelectorAll("product-card-swatch");
    this.priceContainer = this.querySelector(".price");
    this.productForm = this.querySelector("product-form");

    if (this.productForm != null) {
      this.submitButton = this.productForm.querySelector("button");
      this.submitButtonText = this.submitButton?.querySelector("span");
    }
    this.wishlistButton = this.querySelector("add-to-wishlist-button");
    this.badgeContainer = this.querySelector(".card__badge");
    this.init();
  }

  init() {
    this.addEventListener("click", this.storeCurrentCollectionPage.bind(this));
  }
  scrollCarouselToImageId(imageId) {
    this.carousel.scrollToImageID(imageId);
  }
  resetActiveSwatches() {
    this.swatches.forEach((swatch) => {
      swatch.button.classList.remove("active");
    });
  }
  updateLink(href) {
    this.querySelectorAll("a").forEach((a) => (a.href = href));
  }
  updateImages(data) {
    this.carousel.updateImages(data.product.images);
  }
  updateTitle(data) {
    let title = this.querySelector("h3 a");
    title.innerText = data.product.title;
  }
  updateBadge(badge) {
    this.badgeContainer.innerHTML = "";
    if (badge == null) return;

    this.badgeContainer.innerHTML = `
      <span
          class="badge ${badge.badgeClass}"
          style="--colour-custom-badge-background:${badge.badgeBgColour}; ${
            badge.badgeFgColour != ""
              ? `--colour-custom-badge-foreground:${badge.badgeFgColour};`
              : ""
          };"
        >
          ${badge.badgeText}
        </span>
    `;
  }
  updateAddToCartButton(variantId, productId, text) {
    if (this.productForm == null) return;

    if (variantId == null || variantId == undefined) {
      let soldOutMessage = this.submitButton.querySelector(".sold-out-message");
      this.submitButton.setAttribute("aria-disabled", true);
      this.submitButtonText.classList.add("hidden");
      soldOutMessage.classList.remove("hidden");
    } else {
      let soldOutMessage = this.submitButton.querySelector(".sold-out-message");
      this.submitButton.removeAttribute("aria-disabled");
      this.submitButtonText.classList.remove("hidden");
      soldOutMessage.classList.add("hidden");

      this.submitButtonText.innerText = text;

      this.productForm.querySelector('[name="id"').value = variantId;
      this.productForm.querySelector('[name="product-id"').value = productId;
    }
  }
  updatePrice(swatchObject) {
    let { price, compareAtPrice, onSale } = swatchObject;

    if (onSale) {
      this.priceContainer.classList.add("price--on-sale");
      let compareAtPriceContainer = this.priceContainer.querySelector(
        ".price__sale .price-item--regular",
      );
      compareAtPriceContainer.innerHTML = compareAtPrice;
      let priceNowContainer = this.priceContainer.querySelector(
        ".price__sale .price-item--sale",
      );
      priceNowContainer.innerHTML = price;
    } else {
      this.priceContainer.classList.remove("price--on-sale");
      let priceNowContainer = this.priceContainer.querySelector(
        ".price__regular .price-item--regular",
      );
      priceNowContainer.innerHTML = price;
    }
  }
  updateWishlistButton(variantId, onSale = false) {
    //console.log(this.wishlistButton);
    if (this.wishlistButton) {
      this.wishlistButton.setAttribute("data-variant-id", variantId);
      this.wishlistButton.setAttribute("data-on-sale", String(onSale));
      const wishlistButtonElement = this.wishlistButton.querySelector("button");
      if (wishlistButtonElement) {
        wishlistButtonElement.dataset.onSale = String(onSale);
      }
    }
  }
  async fetchData(url) {
    let jsonUrl = `${url}.json`;
    if (jsonUrl in this.productDataCache) {
      return this.productDataCache[jsonUrl];
    }
    let response = await fetch(jsonUrl);
    let data = await response.json();
    this.productDataCache[jsonUrl] = data;
    return data;
  }
  storeCurrentCollectionPage(e) {
    // this interrupts the default link behaviour to save the collection page of the CLICKED card, regardless of whether other pages had been loaded after or previously
    if (e.target.closest(".quick-add__submit, .add-to-cart, .quick-add")) return;
    if (e.target.closest(".product-card--image") || e.target.closest("h3")) {
      // only do this if they clicked on the main product image or the product title, otherwise it breaks the swatches
      e.preventDefault();
      if (this.collectionPage && this.link) {
        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.set("page", this.collectionPage);
        console.log(currentUrl);
        history.replaceState(null, "", currentUrl);
        window.location.href = this.link;
      } else {
        window.location.href = e.target.closest("a").href;
      }
    }
  }
}
customElements.define("product-card", ProductCard);

class ProductCardCarousel extends HTMLElement {
  constructor() {
    super();
    this.scrollTicking = false;
    this.currentImageId = null;
  }

  connectedCallback() {
    this.imageContainer = this.querySelector("[data-product-card-images]");

    if (!this.imageContainer) {
      console.warn("ProductCardCarousel: imageContainer not found");
      return;
    }

    this.imageCount = this.imageContainer.querySelectorAll(
      "[data-id]:not(.hidden)",
    ).length;
    this.productCard = this.closest("product-card");
    this.buttons = this.querySelectorAll("button");

    this.video = this.imageContainer.querySelector("video");
    if (this.video != null) {
      this.setupVideoAutoplay();
    }

    this.imageContainer.addEventListener(
      "scroll",
      this.handleScroll.bind(this),
    );

    if (this.buttons) {
      this.buttons.forEach((button) => {
        button.addEventListener("click", (e) => {
          e.preventDefault();
          this.handleButtonClick(button);
        });
      });
    }

    // Set initial image ID after imageContainer is available
    const firstImage = this.images[0];
    if (firstImage) {
      this.currentImageId = firstImage.dataset.id;
    }
  }

  get images() {
    if (!this.imageContainer) return [];
    this._images = this.imageContainer.querySelectorAll("[data-id]");
    return this._images;
  }
  set images(imageMarkup) {
    if (!this.imageContainer) return;
    this.imageContainer.innerHTML = imageMarkup;
    this._images = this.imageContainer.querySelector("[data-id]");
  }
  get visibleImages() {
    this._visibleImages = this.imageContainer.querySelectorAll(
      "[data-id]:not(.hidden)",
    );
    return this._visibleImages;
  }
  get visibleImageArray() {
    return [...this.visibleImages];
  }
  refereshImageCount() {
    this.imageCount = this.imageContainer.querySelectorAll(
      "[data-id]:not(.hidden)",
    ).length;
  }
  handleButtonClick(button) {
    let currentIndex = this.visibleImageArray.findIndex(
      (image) => image.dataset.id == this.currentImageId,
    );
    let newIndex =
      button.dataset.direction == "left"
        ? Math.max(0, currentIndex - 1)
        : Math.min(currentIndex + 1, this.visibleImageArray.length - 1);
    let newImage = this.visibleImageArray[newIndex];
    this.scrollToImageID(newImage.dataset.id);
  }
  handleScroll(e) {
    if (!this.scrollTicking) {
      window.requestAnimationFrame(() => {
        this.updateActivePage();
        this.scrollTicking = false;
      });
      this.scrollTicking = true;
    }
  }
  updateImages(imageArray) {
    let fragment = document.createDocumentFragment();
    let promises = [];
    imageArray.forEach((image, index) => {
      let imageInContainer = this.getImageById(image.id);
      if (imageInContainer == null) {
        let imageElement = new Image();
        imageElement.src = `${image.src}&width=800`;
        imageElement.width = "800";
        imageElement.height = "800";
        imageElement.alt = image.alt;
        imageElement.setAttribute("data-id", image.id);
        imageElement.classList.add("product-card--image");
        promises.push(
          new Promise((res) => (imageElement.onload = () => res())),
        );
        fragment.appendChild(imageElement);
      }
    });

    if (fragment.children.length > 0) {
      this.imageContainer.appendChild(fragment);

      Promise.all(promises).then(() => {
        this.images.forEach((image) => image.classList.add("hidden"));
        imageArray.forEach((image) => {
          let imageElement = this.getImageById(image.id);
          if (imageElement) {
            imageElement.classList.remove("hidden");
          }
        });
        let firstImageId = imageArray[0].id;
        this.scrollToImageID(firstImageId);
      });
    } else {
      this.images.forEach((image) => image.classList.add("hidden"));
      imageArray.forEach((image) => {
        let imageElement = this.getImageById(image.id);
        if (imageElement) {
          imageElement.classList.remove("hidden");
        }
      });
      let firstImageId = imageArray[0].id;
      this.scrollToImageID(firstImageId);
    }
  }
  getImageById(imageId) {
    let image = this.imageContainer.querySelector(`[data-id='${imageId}']`);
    return image;
  }
  scrollToImage(image) {
    this.images.forEach((im) => im.setAttribute("aria-hidden", true));
    image.setAttribute("aria-hidden", false);
    this.imageContainer.scrollTo({
      left: image.offsetLeft,
      behavior: "smooth",
    });
    this.updateActivePage();
  }
  scrollToImageID(imageId) {
    let image = this.getImageById(imageId);
    if (image != null) {
      this.scrollToImage(image);
    }
  }
  updateActivePage() {
    let imageWidth = this.visibleImages[0].getBoundingClientRect().width;
    let currentIndex = Math.floor(this.imageContainer.scrollLeft / imageWidth);
    let currentImage = this.visibleImages[currentIndex];
    this.currentImageId = currentImage.dataset.id;

    this.buttons.forEach((button) => button.removeAttribute("disabled"));

    if (currentIndex < 1) {
      this.querySelector('button[data-direction="left"').setAttribute(
        "disabled",
        true,
      );
    } else if (currentIndex == this.visibleImageArray.length - 1) {
      this.querySelector('button[data-direction="right"').setAttribute(
        "disabled",
        true,
      );
    }
  }
  setupVideoAutoplay() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(
        (entry) => {
          if (entry.isIntersecting) {
            this.video.play();
            observer.unobserve(this.video);
          }
        },
        {
          rootMargin: "0 0 500px 0",
          threshold: 1.0,
        },
      );
    });
    observer.observe(this.video);
  }
}
customElements.define("product-card-carousel", ProductCardCarousel);

class ProductCardSwatch extends HTMLElement {
  constructor() {
    super();

    this.type = this.dataset.type;
    this.productId = this.dataset.productId;
    this.productUrl = this.dataset.productUrl;
    this.variantId = this.dataset.variantId;
    this.sampleVariantId = this.dataset.sampleVariantId;
    this.imageId = this.dataset.imageId;

    this.price = this.dataset.price;
    this.compareAtPrice = this.dataset.compareAtPrice;
    this.onSale = this.dataset.onSale == "true";

    this.priceObj = {
      price: this.price,
      compareAtPrice: this.compareAtPrice,
      onSale: this.onSale,
    };

    this.badge = this.dataset.badgeText
      ? {
          badgeText: this.dataset.badgeText,
          badgeBgColour: this.dataset.badgeBgColour,
          badgeFgColour: this.dataset.badgeFgColour,
          badgeClass: this.dataset.badgeClass,
        }
      : null;
  }

  connectedCallback() {
    this.productCard = this.closest("product-card");
    this.button = this.querySelector("button");

    if (this.button) {
      this.button.addEventListener("click", (e) => {
        e.preventDefault();
        this.handleButtonClick();
      });
    }
  }

  disconnectedCallback() {
    if (this.button) {
      this.button.removeEventListener("click", this.handleButtonClick);
    }
  }
  getAddToCartId() {
    return this.sampleVariantId ?? this.variantId;
  }
  handleButtonClick() {
    //if (this.button.classList.contains('active')) return;

    this.productCard.resetActiveSwatches();
    this.button.classList.add("active");

    this.productCard.updateLink(this.productUrl);
    this.productCard.updatePrice(this.priceObj);
    let text = this.sampleVariantId
      ? this.productCard.orderSampleText
      : this.productCard.addToCartText;
    this.productCard.updateAddToCartButton(
      this.getAddToCartId(),
      this.productId,
      text,
    );
    this.productCard.updateWishlistButton(this.variantId, this.onSale);

    if (this.type == "variant") {
      if (this.imageId != null) {
        this.productCard.scrollCarouselToImageId(this.imageId);
        this.productCard.updateBadge(this.badge);
      }
    } else {
      this.productCard.fetchData(this.productUrl).then((data) => {
        this.productCard.updateImages(data);
        this.productCard.updateTitle(data);
        this.productCard.updateBadge(this.badge);
      });
    }
  }
}
customElements.define("product-card-swatch", ProductCardSwatch);

class CustomSelectElement extends HTMLElement {
  constructor() {
    super();
    this.colourSwatchData = null;

    this.originalSelect = this.querySelector("select");
    this.optionList = this.originalSelect.querySelectorAll("option");
    this.customSelect = this.querySelector("[data-custom-select]");
    this.customSelectOptionsContainer = this.customSelect.querySelector(
      ".custom-select-options",
    );
    this.customSelectTrigger = this.customSelect.querySelector(
      ".custom-select-trigger",
    );
    this.defaultLabel =
      this.customSelectTrigger.innerHTML.trim() == ""
        ? null
        : this.customSelectTrigger.innerHTML;

    this.customSelectTrigger.addEventListener("click", (e) => {
      let isClosed = !this.hasAttribute("open");

      if (isClosed) {
        this.openCustomSelect();
      } else {
        this.closeCustomSelect();
      }
    });
    this.originalSelect.addEventListener("change", (e) => {
      let value = e.target.value;
      this.setCustomSelectValue(value);
    });
  }
  connectedCallback() {
    if (this.optionList != null) {
      this.optionList.forEach((option) => {
        let optionText = option.innerText;
        let optionDiv = document.createElement("div");
        optionDiv.classList.add("custom-select-option");
        optionDiv.dataset.value = option.value;
        optionDiv.innerHTML = `
            <div class='custom-select-option--text-container'>
              <span class='custom-select-option--text'>${optionText}</span>
            </div>
          `;
        if (option.selected) {
          this.dataset.value = option.value;
          optionDiv.classList.add("active");
          if (this.defaultLabel == null) {
            this.customSelectTrigger.innerHTML = optionDiv.innerHTML;
          }
        }
        this.customSelectOptionsContainer.appendChild(optionDiv);
      });
      this.customSelectOptions =
        this.customSelectOptionsContainer.querySelectorAll(
          ".custom-select-option",
        );
      this.customSelectOptions.forEach((option) => {
        option.addEventListener("click", (e) => {
          e.preventDefault();
          this.handleCustomOptionClick(option);
        });
      });
      if (this.defaultLabel != null) {
        this.customSelectTrigger.innerHTML = this.defaultLabel;
      }
    }
  }
  handleCustomOptionClick(option) {
    let value = option.dataset.value;
    this.originalSelect.value = value;
    this.originalSelect.dispatchEvent(new Event("change", { bubbles: true }));
    this.originalSelect.dispatchEvent(new Event("input", { bubbles: true }));
    this.setCustomSelectValue(value);
    this.closeCustomSelect();
  }
  setCustomSelectValue(value) {
    this.dataset.value = value;
    this.customSelectOptions.forEach((option) =>
      option.classList.remove("active"),
    );
    let optionEl = this.customSelectOptionsContainer.querySelector(
      `[data-value="${value}"]`,
    );
    optionEl.classList.add("active");
    if (this.defaultLabel != null) {
      this.customSelectTrigger.innerHTML = this.defaultLabel;
    } else {
      this.customSelectTrigger.innerHTML = optionEl.innerHTML;
    }
  }
  openCustomSelect() {
    this.setAttribute("open", "");
    this.customSelect.setAttribute("aria-hidden", false);
    document.addEventListener("click", this.watchClickOutside.bind(this));
    document.addEventListener(
      "keydown",
      this.supportKeyboardNavigation.bind(this),
    );
  }
  closeCustomSelect() {
    this.removeAttribute("open");
    this.customSelect.setAttribute("aria-hidden", true);

    document.removeEventListener("click", this.watchClickOutside);
    document.removeEventListener("keydown", this.supportKeyboardNavigation);
  }
  watchClickOutside(e) {
    const didClickedOutside = !this.customSelect.contains(e.target);
    if (didClickedOutside) {
      this.closeCustomSelect();
    }
  }
  supportKeyboardNavigation(e) {
    // press ESC -> close selectCustom
    if (e.keyCode === 27) {
      this.closeCustomSelect();
    }
  }
}
customElements.define("custom-select", CustomSelectElement);

/** general helper function to check user is logged in using login wrapper */
async function handleLogIn() {
  // if the customer is logged in, set their customer id, if not take them to the login page
  return new Promise(async (resolve, reject) => {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${root}?sections=customer-login-wrapper`); // fetch it fresh in case they have gone "back" in the browser ;)
    const tmpHTML = document.createElement("customer-login-wrapper");
    tmpHTML.innerHTML = data["customer-login-wrapper"];
    const customerLoginWrapper = tmpHTML.querySelector(
      "customer-login-wrapper",
    );
    if (!customerLoginWrapper) reject();

    const loggedIn = Number(customerLoginWrapper.dataset.loggedIn);
    const customerId = Number(customerLoginWrapper.dataset.customerId);

    if (loggedIn && customerId && loggedIn > 0 && customerId > 0) {
      resolve(customerId);
    } else {
      resolve(false);
    }
  });
}

/** general function to add a product to the wishlist if a user was redirected through login */
